export const COUNTRIES = [
  { name: "Koweït", code: "KW" },
  { name: "Arabie Saoudite", code: "SA" },
  { name: "Égypte", code: "EG" },
  { name: "Émirats Arabes Unis", code: "AE" },
  { name: "Qatar", code: "QA" },
  { name: "Bahreïn", code: "BH" },
  { name: "Oman", code: "OM" },
  { name: "Jordanie", code: "JO" },
  { name: "Palestine", code: "PS" },
  { name: "Liban", code: "LB" },
  { name: "Syrie", code: "SY" },
  { name: "Irak", code: "IQ" },
  { name: "Yémen", code: "YE" },
  { name: "Maroc", code: "MA" },
  { name: "Algérie", code: "DZ" },
  { name: "Tunisie", code: "TN" },
  { name: "Libye", code: "LY" },
  { name: "Soudan", code: "SD" },
  { name: "Mauritanie", code: "MR" },
  { name: "Somalie", code: "SO" },
  { name: "Djibouti", code: "DJ" },
  { name: "Comores", code: "KM" },
];

export default COUNTRIES;
